//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { setQueryParam } from '@utils/urlUtils';
import { STREAM_CONTAINER_ID_QUERY_PARAM } from '@streams-drawer/streams-drawer-constants';

export const setSelectedStreamQueryParam = (
  selecteStreamId: string | undefined,
) => {
  const urlWithContainerId = setQueryParam(
    window.location.href,
    STREAM_CONTAINER_ID_QUERY_PARAM,
    selecteStreamId,
  );
  history.replaceState(null, '', urlWithContainerId);
};
